/*
 * @Description: 单对象页面-子表组件 的mixin
 */
import detailbuttons from './detailbuttons.vue';
// import tableDetailCollectionSlot from './tableDetailCollectionSlot.vue';
import { handleRealTimeStoreQty,tableConfig } from './utils';
import { mapMutations } from 'vuex';

const STMixin = {
  slotArray: {
    detailbuttonsa: detailbuttons, //子表按钮的文件
  },
  slotTableTemplate: () => import('./tableDetailCollectionSlot.vue'), // 子表渲染的逻辑的文件,
  watch: {
    '$store.state.omsStore.objectTableItem': {
      handler(val) {

        setTimeout(() => {
          this.forRealtimeInventory();
        }, 100);
      },
      immediate: true,

    },
    columns:{
      handler(val) {
        setTimeout(() => {
          this.forRealtimeInventory();
        }, 100);

      },
    }
  },
  updated() {

    const { itemId, tableId, tableName } = this.$router.currentRoute.params;
    this.$nextTick(() => {
      if (tableName == 'OC_B_VIPCOM_DISTRIBUTION') {
        console.log('单对象明细部分的mixin:');
        const configData = this.mainFormInfo.formData;
        if (!configData.data.addcolums) {
          return;
        }
        const obj = configData.data.addcolums[0].childs.find((i) => i.colname == 'IS_COPY')
        const statusObj = configData.data.addcolums[0].childs.find((i) => i.colname == 'STATUS')
        const isCopyObj = obj && obj.valuedata;
        const STATUS = statusObj && statusObj.valuedata;

        const configData_sub = this.tabPanel[0].componentAttribute.formData;
        const configData_subBtn = this.tabPanel[0].componentAttribute.buttonsData;

        const itemOnlyTow = () => {
          const showArr = ['PS_C_SKU_ID', 'TOT_QTY_OUT'];
          configData_sub.data.inpubobj = configData_sub.data.inpubobj.filter((i) => showArr.includes(i.colname));
        };
        const configData_objectTab = this.mainFormInfo.buttonsData;
        const canEdit = () => {
          // 放开保存按钮 及 去掉所有 表单不可编辑限制
          // configData_objectTab.data.tabcmd.prem[0] = true // actionADD
          // configData_objectTab.data.tabcmd.prem[1] = true // actionMODIFY
          // configData_objectTab.data.objreadonly = false
        };
        const readonlyFn = (editArr, disabledArr) => {
          // configData.data.addcolums[0].childs.forEach(i => {
          //   if (editArr.includes(i.colname)) {
          //     i.readonly = false
          //   } else if (disabledArr.includes(i.colname)) {
          //     i.readonly = true
          //   }
          // })
        };
        const noImport = () => {
          configData_subBtn.data.tabcmd.prem[2] = false; // actionIMPORT
        };
        const onlyExport = () => {
          configData_subBtn.data.tabcmd.prem[0] = false; // actionMODIFY
          configData_subBtn.data.tabcmd.prem[1] = false; // actionDELETE
          configData_subBtn.data.tabcmd.prem[2] = false; // actionIMPORT
        };
        if (isCopyObj == '1') {
          itemOnlyTow();
          if (STATUS == '2') {
            // 缺货
            console.log('mixin:STATUS::', 2);
            canEdit();
            const editArr = ['CP_C_LOGISTICS', 'DELIVERY_METHOD', 'CP_C_PHY_WAREHOUSE', 'REMARK'];
            const disabledArr = ['SPLIT_TYPE', 'BILL_TYPE', 'PS_C_BRAND_ENAME', 'WAREHOUSE_CODE'];
            readonlyFn(editArr, disabledArr);
            noImport();
          } else if (STATUS == '8') {
            // 占单成功
            console.log('mixin:STATUS::', 8);
            canEdit();
            const editArr = ['CP_C_LOGISTICS', 'DELIVERY_METHOD', 'REMARK'];
            const disabledArr = ['SPLIT_TYPE', 'BILL_TYPE', 'PS_C_BRAND_ENAME', 'WAREHOUSE_CODE', 'CP_C_PHY_WAREHOUSE_ID'];
            readonlyFn(editArr, disabledArr);
            onlyExport();
          } else {
            console.log('mixin:其它::', STATUS);
            onlyExport();
          }
        }
      }
    });
  },
  mounted() {
    console.log('src/config/minxin/standardTable/mixin.js');
    window.addEventListener(
      'notificationOfMain',
      (data) => {

        // _this.forRealtimeInventory()
      },
      true
    );
  },
  methods: {
    ...mapMutations('omsStore', [
      'up_PS_C_PRO_LOG_DATA',
      'upDrawerForPsCProEname',
      'upOrderSpecialDateRow',
      'upOrderSpecialDateShow',
      'upOrderReceivingRow',
      'upOrderReceivingTimeShow'
    ]),
    /* 定制明细的导出也可以不用动元数据，在此定义 R3_openedApi_export 方法即可：
    R3_openedApi_export() {
      if (tableName == "a") {
        // 自定义导出
      } else {
        this.objectEXPORT(); // 标准的导出
      }
    } */
    async forRealtimeInventory() {

      handleRealTimeStoreQty(this);

    },
    resetTableData(val) {
      const { _rows, storeId = '', saStoreId = '' } = val;
      if (!_rows.length) {
        return;
      }
      const itemList = _rows.reduce((a, b) => {
        let obj = {};
        obj.itemId = b.ID;
        obj.storeId = storeId;
        obj.saStoreId = saStoreId;
        obj.psCSkuEcode = b.PS_C_SKU_ID || b.PS_C_SKU_ECODE;
        a.push(obj);
        return a;
      }, []);
      const params = {
        time: -new Date(),
        itemList: itemList,
      };
      this.service.inventoryCenter.storageQuery(params).then((res) => {
        if (res.data.code == 0 && res.data.data.length) {
          _rows.forEach((i) => {
            res.data.data.forEach((x) => {
              if (i.ID == x.itemId) {
                i.SENDER_SA_STORE_QTY = x.saStorage;
                i.SENDER_STORE_QTY = x.lsStorage;
                if (!saStoreId) {
                  i.SENDER_SA_STORE_QTY = t('请选择发货配销仓');
                }
                if (!storeId) {
                  i.SENDER_STORE_QTY = t('请选择发货逻辑仓');
                }
              }
            });
          });
          this.tabledata = _rows;
        }
      });
    },
    columnRenderer(cellData, render) {
      // handleRealTimeStoreQty(this)
      const { tableName } = vm.$route.params;
      if (tableName == 'PS_C_PRO' && this.tableName == "PS_C_PRO_LOG" && ['BMOD', 'AMOD'].includes(cellData.colname)) {
        // 商品SPU - 操作日志 - 修改前/修改后
        render.renderComponent = (h, params) => {
          const content = params.row[cellData.colname]
          if (["商品素材"].includes(params.row.MODCONTENT)) { // 修改内容 == '商品素材'
            if (content) {
              return h('a' , {
                on:{
                  click:()=>{
                    this.up_PS_C_PRO_LOG_DATA(content) // 弹【图文详情】的弹窗
                  }
                }
              }, `版本：${content} 🔍`)
            } else {
              return h('span', { }, content)
            }
          } else {
            return h('span', { }, content)
          }
        }
      }
      if (tableName == 'SG_C_PRE_SALE_PLAN' && cellData.colname == 'ISACTIVE') {
        // 预售计划单 - 预售明细 - 可用
        render.renderComponent = (h, params) => {
          let status
          const page = this.$store.state[R3.getModuleName()]
          if (page && page.copyDataForReadOnly.addcolums[0]) {
            const obj = page.copyDataForReadOnly.addcolums[0].childs.find(i => i.colname == 'BILL_STATUS')
            obj && (status = obj.valuedata)
          }
          if (status != '2') return h('span', {}, params.value) // 单据状态已审核才可编辑
          const EXCEPT_COLUMN_NAME = 'ID'; // 排除显示列（ID）
          return h('div', {}, [
            h('i-switch', {
              props: {
                value: params.value == '是'
              },
              on: {
                'on-change': (val) => {
                  let curValue = val ? 'Y' : 'N'
                  let oldIdValue = this.dataSource.row[params.index][cellData.colname].val;
                  this.copyDataSource.row[params.index][cellData.colname].val = curValue;
                  this.putDataFromCell(curValue, oldIdValue, cellData.colname, this.dataSource.row[params.index][EXCEPT_COLUMN_NAME].val, params.column.type);
                  this.putLabelDataFromCell(curValue, oldIdValue, cellData.colname, this.dataSource.row[params.index][EXCEPT_COLUMN_NAME].val, oldIdValue);
                  document.querySelector('#actionMODIFY').click() // 触发保存
                }
              }
            }, [
              h('span', { slot: 'open' }, '是'),
              h('span', { slot: 'close' }, '否'),
            ])
          ])
        }
      }
      if (tableName == 'ST_C_STORE_SETTING' && ['DATEINV','ORDER_TIME_SETTING', 'BUSINESS_TIME', 'SPECIAL_TIME_UN_DISPATCH'].includes(cellData.colname)) {
        // 全渠道门店设置 - 门店信息 - 接单时间设置/营业时间/特殊日期不派单/'盘点日期/时间'
        if (!$('.R3-buttonList #actionMODIFY')[0]) return // 没有保存按钮
        render.renderComponent = (h, params) => {
          const val = params.row[cellData.colname]
          const content = val.split(',').map(i => {
            return h('span', {
              attrs: {
                title: val,
              },
              style: {
                margin: '0 4px',
                display: 'inline-block',
                'border-bottom': '1px solid #ccc',
                height: '18px',
                'line-height': '18px',
              }
            }, i)
          })
          return h('div', {
            style: {
              maxWidth: '280px',
              overflow: 'hidden',
              'text-overflow': 'ellipsis',
            },
          }, [...content,
          h('i', {
            class: 'iconfont icon icon-Edit',
            style: {
              color: 'var(--b2-color)',
              cursor: 'pointer',
              position: 'absolute',
              right: '8px',
            },
            on: {
              click: () => {
                const obj = {}
                if (cellData.colname == 'DATEINV') {
                  const updateObj = vm.$store.state[R3.getModuleName()].updateData.ST_C_STORE_SETTING_ITEM
                  if (updateObj.modify.ST_C_STORE_SETTING_ITEM.length) {
                    const rowModify = updateObj.modify.ST_C_STORE_SETTING_ITEM.find(i => i.ID == params.row.ID)
                    if (rowModify.hasOwnProperty('INV_TYPE')) {
                      obj['INV_TYPE'] = rowModify.INV_TYPE
                    }
                  } else {
                    obj['INV_TYPE'] = params.row.INV_TYPE == '每月' ? '2' : '1'
                  }
                  console.log('INV_TYPE::', obj);
                }
                if (['BUSINESS_TIME', 'ORDER_TIME_SETTING', 'DATEINV'].includes(cellData.colname)) {
                  this.upOrderReceivingTimeShow(true) // 弹'接单时间设置/营业时间'的弹窗
                  this.upOrderReceivingRow({...Object.assign({}, params.row, obj), currentColumn: cellData.colname})
                } else {
                  this.upOrderSpecialDateShow(true) // 弹'特殊日期不派单'的弹窗
                  this.upOrderSpecialDateRow(params.row)
                }
              }
            },
          })
          ])
        };
      }
      // 客户订单编辑 - 商品信息 - 商品名称 - 点击右边滑出库存占用明细
      if (tableName == 'DC_B_ORDER' && cellData.colname === 'PS_C_PRO_ENAME') {
        const item = $store.state[R3.getModuleName()].mainFormInfo.formData.data.addcolums[0].childs.find(i => i.colname == 'STATUS')
        if (!item) {
          return
        }
        if (['3','4'].includes(item.valuedata)) {
          render.renderContainer = 'CellRenderByFunction';
          render.renderComponent = (h, params) => {
            const name = params.row.PS_C_PRO_ENAME
            return h('div', [
              h('i', {
                // class: 'iconfont iconbj_link',
                style: {
                  fontSize: '12px',
                  color: '#0f8ee9',
                  cursor: 'pointer',
                },
                on: {
                  click: () => {
                    console.log('params.row.ID', params.row.ID);
                    this.upDrawerForPsCProEname(params.row.ID)
                  },
                },
              }, `${name}`),
            ]);
          }
        }
      }
      //  ['SG_B_STO_TRANSFER', 'SG_B_CHANNEL_TRANSFER'].includes(tableName)
      if (tableConfig[tableName] && ['SENDER_STORE_QTY', 'SENDER_SA_STORE_QTY'].includes(cellData.colname)) {


        render.renderComponent = (h, params) => {
          let color = '#000',
            fontWeight = 600;
          if ((params.row[cellData.colname] + '').includes('请选择')) {
            color = '#ccc';
            fontWeight = 500;
          }
          return h(
            'div',
            {
              style: {
                height: '100%',
                color,
                // fontWeight
              },
            },
            params.row[cellData.colname]
          );
        };
      }
      // 门店配货计划编辑 - 子表表格中，根据状态(配货状态)控制input(指定配货数量、计划配货数量)是否可编辑
      if (tableName == 'SG_B_STO_STORE_DISTRIBUTION' && ['SPECIFY_DISTRIBUTION_QTY', 'PLAN_DISTRIBUTION_QTY'].includes(cellData.colname)) {
        const EXCEPT_COLUMN_NAME = 'ID'; // 排除显示列（ID）
        render.renderComponent = (h, params) => {
          /* if (params.row.DISTRIBUTION_STATUS == t("配货完成")) {
            return h('span', { }, params.row[cellData.colname])
          } */
          let rowData = this.copyDataSource.row[params.index];
          let colnameData = this.copyDataSource.row[params.index] ? this.copyDataSource.row[params.index][cellData.colname] : {};
          return h(
            'div',
            {
              style: {
                overflow: 'hidden',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
              },
              class: {
                'flex-right': cellData.tdAlign === 'right',
                'flex-center': cellData.tdAlign === 'center',
                'flex-left': cellData.tdAlign === 'left',
                'table-input': true,
              },
            },
            [
              h('Input', {
                style: {
                  // width: '100px',
                  maxWidth: cellData.width ? cellData.width : '100px',
                  minWidth: cellData.width ? undefined : '100px',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                },
                class: {
                  'flex-right': cellData.tdAlign === 'right', // 组件对齐
                  'flex-center': cellData.tdAlign === 'center',
                  'flex-left': cellData.tdAlign === 'left',
                  'input-align-right': cellData.tdAlign === 'right', // 输入框文本对齐
                  'input-align-center': cellData.tdAlign === 'center',
                  'input-align-left': cellData.tdAlign === 'left',
                  [`ag-${params.index}-${params.column._index - 1}`]: true, // 联动计算标记
                },
                domProps: {
                  id: `${params.index}-${params.column._index - 1}`,
                  title: colnameData ? colnameData.val : '',
                },
                props: {
                  disabled: rowData.DISTRIBUTION_STATUS.val == t('配货完成'),
                  value: colnameData ? colnameData.val : '',
                  regx: this.inputRegx(cellData, params),
                  maxlength: cellData.length,
                },
                nativeOn: {},
                on: {
                  'on-change': (event, data) => {
                    // 通过修改dom属性,控制数字类型的长度
                    // *如果通过双向数据绑定改会导致整个表格重绘
                    if (cellData.type === 'NUMBER') {
                      const value = event.target.value;
                      let valLength = cellData.length;
                      const isNegativeDecimal = value.split('.').length > 1 && value.split('-').length > 1; // 是否是负小数
                      const isDecimal = value.split('.').length > 1 && value.split('+').length > 1; // 是否是正小数
                      if (isNegativeDecimal || isDecimal) {
                        // 正负小数
                        valLength = valLength + 2;
                      } else if (value.split('.').length > 1) {
                        // 小数
                        valLength = valLength + 1;
                      } else if (value.split('-').length > 1 || value.split('+').length > 1) {
                        // 正负整数
                        valLength = valLength + 1;
                      }
                      event.target.maxLength = valLength;
                    }

                    const currentRowData = this.copyDataSource.row[params.index];
                    currentRowData[cellData.colname].val = event.target.value;

                    const oldCurrentValue = this.dataSource.row[params.index][cellData.colname].val;
                    const oldId = this.dataSource.row[params.index][EXCEPT_COLUMN_NAME].val;

                    // 是否进行联动计算
                    if (window.ProjectConfig.computeForSubtable && cellData.webconf && cellData.webconf.dynamicforcompute) {
                      const dynamicforcompute = cellData.webconf.dynamicforcompute;
                      const oldTargetValue = this.dataSource.row[params.index][dynamicforcompute.computecolumn].val;
                      // 找到目标字段相关的信息
                      const targetColObj = this.columns.find((colObj) => colObj.colname === dynamicforcompute.computecolumn);

                      // 提交变化字段
                      this.putDataFromCell(event.target.value, oldCurrentValue, cellData.colname, oldId, params.column.type);
                      this.putLabelDataFromCell(event.target.value, data.value, cellData.colname, oldId, oldCurrentValue);

                      const newTargetValue = this.getComputedValue(currentRowData, targetColObj, dynamicforcompute, params);
                      // 提交联动的目标字段
                      this.putDataFromCell(newTargetValue, oldTargetValue, dynamicforcompute.computecolumn, oldId, targetColObj.type);
                      this.putLabelDataFromCell(newTargetValue, oldTargetValue, dynamicforcompute.computecolumn, oldId, oldTargetValue);
                    } else {
                      this.putDataFromCell(event.target.value, oldCurrentValue, cellData.colname, oldId, params.column.type);
                      this.putLabelDataFromCell(event.target.value, data.value, cellData.colname, oldId, oldCurrentValue);
                    }
                  },
                  'on-focus': (e, i) => {},
                  'on-keydown': (e, i) => {
                    if (e.keyCode === 13) {
                      // 回车
                      const elementId = i.$el.id;
                      this.tableCellFocusByEnter(elementId);
                    } else if (e.keyCode === 40) {
                      // 下键
                      const elementId = i.$el.id;
                      const currentColumn = params.column._index - 1;
                      this.tableCellFocusByUpOrDown(elementId, currentColumn, 'down');
                    } else if (e.keyCode === 38) {
                      // 上键
                      const elementId = i.$el.id;
                      const currentColumn = params.column._index - 1;
                      this.tableCellFocusByUpOrDown(elementId, currentColumn, 'up');
                    }
                  },
                  'on-blur': (e) => {
                    const oldValue = e.target.value;
                    if (typeof oldValue === 'string') {
                      e.target.value = oldValue.trim();
                    }
                  },
                },
              }),
            ]
          );
        };
      }
      // 渠道需求预计交付计划编辑 - 调拨执行结果查询 - 链接
      if (tableName == 'SG_B_CHANNEL_DEMAND_DELIVER_PLAN' && cellData.colname === 'FILE_URL') {
        render.renderContainer = 'CellRenderByFunction';
        render.renderComponent = (h, params) => {
          /* if (render.renderComponent) {
            render.renderComponent.call(vm)
          } */
          const url = params.row.FILE_URL;
          const start = url.indexOf('%');
          const end = url.lastIndexOf('?');
          const filename = decodeURI(url.substring(start, end));
          console.log('params::', params.row);
          return h('div', [
            h(
              'i',
              {
                class: 'iconfont iconbj_link',
              style: {
                  fontSize: '12px',
                  color: '#0f8ee9',
                cursor: 'pointer',
              },
              on: {
                click: () => {
                    const _module = vm.$route.meta.moduleName.replace(/\./g, '-');
                    console.log('filename::', filename);
                    const downloadFn = function (src) {
                      const download_file = {};
                      if (typeof download_file.iframe === 'undefined') {
                        const iframe = document.createElement('iframe');
                        download_file.iframe = iframe;
                        document.body.appendChild(download_file.iframe);
                }
                      download_file.iframe.src = src;
                      download_file.iframe.style.display = 'none';
                    };
                    downloadFn(url);
                    vm.$R3loading.hide(_module);
                  },
                },
              },
              ` ${filename}`
            ),
          ]);
        };
      }
      // 财审策略编辑 - 策略明细 - 识别内容
      if (tableName == 'ST_C_FINANCIAL_AUDIT' && cellData.colname === 'IDENTIFY_CONTENT') {
        render['renderContainer'] = 'CellRenderByFunction';
        render.renderComponent = (h, params) => {
          const content = params.row.IDENTIFY_CONTENT;
          let label = content;
          if (params.row.IDENTIFY_TYPE == '付款方式') {
            const options = vm.$store.state.omsStore.omsAllOptions['PAY_TYPE'];
            label = options.find((i) => i.value == content).label;
          }
          return h('span', {}, label);
        };
      }
      // 出库通知单编辑 - 礼品卡明细 - 图片
      if (tableName == 'SG_B_STO_OUT_NOTICES' && cellData.colname === 'PICTURE') {
        render['renderContainer'] = 'CellRenderByFunction';
        render.renderComponent = (h, params) => {
          let src = 'https://r3standard-zjk-oss.oss-cn-zhangjiakou.aliyuncs.com/img/emptyImg.png';
          const { PICTURE } = params.row;
          if (PICTURE && PICTURE.includes('http')) {
            src = PICTURE;
          }
          return h(
            'Poptip',
            {
              props: {
                transfer: true,
                trigger: 'hover',
                placement: 'right',
              },
            },
            [
              h('el-image', {
                style: {
                  // width: '41px',
                  height: '27px',
                  // 'vertical-align': 'middle',
                },
                props: {
                  fit: 'cover',
                  src,
                  'preview-src-list': [src],
                },
              }),
              h('div', {
                slot: 'content',
                style: {
                  'background-position': 'center',
                  'background-repeat': 'no-repeat',
                  'background-size': 'auto 100%',
                  backgroundImage: `url(${src})`,
                  height: '200px',
                  width: '200px',
                },
              }),
            ]
          );
        };
      }
    },
    /**
     * 处理ag表格配置项
     * @param options
     * @returns {*}
     * @constructor
     */
    R3_processAgOptions(options) {
      options.rowHeight = this.$store.state.customize.baseHeight; // 设置表格行高
      return options;
    },
    R3_processColumns(columns) {
      columns.forEach(item => {
        if (vm.$route.fullPath.includes('/SYSTEM/TABLE_DETAIL/')) {
          // 调整表头展示的Label
          if (['SG_B_STO_OUT_RESULT', 'SG_B_STO_IN_RESULT'].includes(vm.$route.params.tableName)) {
            if (item.colname == "SG_C_PRO_SN_ECODE") {
              item.name = t('SN码')
            }
          }
        }
        // 客户订单编辑-商品信息-子表联动计算
        if (vm.$route.params.tableName === "DC_B_ORDER") {
          if (item.colname == "QTY") { // '数量' 变更
            item.webconf = {}
            item.webconf.dynamicforcompute = [
              {
                "computecolumn":"AMT_LIST", // 吊牌金额(AMT_LIST) = 数量 * 吊牌价(PRICE_LIST)
                "express":"PRICE_LIST * QTY",
                "refcolumns":[
                  "PRICE_LIST",
                  "QTY"
                ]
              },
              {
                "computecolumn":"AMT_SALE", // 销售金额(AMT_SALE) = 数量 * 销售价(PRICE_SALE)
                "express":"PRICE_SALE * QTY",
                "refcolumns":[
                  "PRICE_SALE",
                  "QTY"
                ]
              },
            ]
          } else if (item.colname == "PRICE_SALE") { // '销售价' 变更
            item.webconf = {}
            item.webconf.dynamicforcompute = [
              {
                "computecolumn":"DISCOUNT", // 折扣(DISCOUNT) = 销售价 / 吊牌价
                "express":"PRICE_SALE / PRICE_LIST",
                "refcolumns":[
                  "PRICE_SALE",
                  "PRICE_LIST"
                ]
              },
              {
                "computecolumn":"AMT_SALE", // 销售金额 = 数量 * 销售价
                "express":"PRICE_SALE * QTY",
                "refcolumns":[
                  "PRICE_SALE",
                  "QTY"
                ]
              },
            ]
          } else if (item.colname == "AMT_SALE") { // '销售金额' 变更
            item.webconf = {}
            item.webconf.dynamicforcompute = [
              {
                "computecolumn":"PRICE_SALE", // 销售价 = 销售金额 / 数量
                "express":"AMT_SALE / QTY",
                "refcolumns":[
                  "AMT_SALE",
                  "QTY"
                ]
              },
              {
                "computecolumn":"DISCOUNT", // '销售价'变更触发的同步变更: 折扣(DISCOUNT) = 销售价 / 吊牌价
                "express":"PRICE_SALE / PRICE_LIST",
                "refcolumns":[
                  "PRICE_SALE",
                  "PRICE_LIST"
                ]
              },
            ]
          }
        }
        if (vm.$route.params.tableName === "DC_B_RETURN_ORDER" && vm.$route.params.itemId != "New") {
          if (['QTY','RETURN_PRICE'].includes(item.colname)) { // 数量和价格，只有在待审核才能编辑
            const dex = this.mainFormInfo.formData.data.addcolums[0].childs.findIndex(i => i.colname == "ORDER_STATUS")
            if (dex != -1) {
              if(this.mainFormInfo.formData.data.addcolums[0].childs[dex].valuedata == "1") {
                item.ismodify = true
              } else {
                item.ismodify = false
              }
            } else {
              $fcError(t('条码明细中【数量】【退货价】只有在【单据状态】为【待审核】时才能编辑，现获取【单据状态(ORDER_STATUS)】失败！'))
            }
          }
        }
        // item.thAlign = 'center'
      });
      return columns;
    },
  },
};
export default STMixin;
